import { render, staticRenderFns } from "./HelpWithMyOrderEBook.vue?vue&type=template&id=e4f5ca04&scoped=true"
import script from "./HelpWithMyOrderEBook.vue?vue&type=script&lang=js"
export * from "./HelpWithMyOrderEBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f5ca04",
  null
  
)

export default component.exports